import React from "react";

const Button = ({
	label,
	variant = "primary", // "primary" | "secondary"
	disabled = false,
	className = "",
	...props
}) => {
	const base =
		"py-2 rounded-md transition-colors";

	const primary =
		"bg-indigo-500 text-white hover:bg-indigo-700";

	const secondary =
		"border border-indigo-500 text-indigo-600 bg-transparent hover:bg-indigo-50 hover:text-indigo-700";

	const disabledStyle =
		"opacity-50 cursor-not-allowed pointer-events-none";

	const combinedClassName = [
		"px-5", // sensible default
		base,
		variant === "primary" ? primary : secondary,
		disabled && disabledStyle,
		className, // user overrides / extensions LAST
	]
		.filter(Boolean)
		.join(" ");

	return (
		<button
			{...props}
			disabled={disabled}
			className={combinedClassName}
		>
			{label}
		</button>
	);
};

export default Button;